import { CREATE_USER_FORM_COMPACTING_REPORT, FETCH_COMPACTING_REPORTS_DATA_FAILURE, FETCH_COMPACTING_REPORTS_DATA_REQUEST, FETCH_COMPACTING_REPORTS_DATA_SUCCESS, SET_SUMMARY_GRID_NAME_COMPACTING_REPORT_DK } from "./compactingReport.actionType";


export const COMPACTING_REPORT = 'compactingreports';

let initialState = {
    loading: false,
    compactingReportData: [],
    compactingMasterMainList: [],
    compactingWiseUserform: {
        fldFKUnitId: -1,
        fldProgram: '',
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date()
    },
    renderGridBtn: 'summaryGrid',

};

export let compactingReportsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_COMPACTING_REPORTS_DATA_REQUEST:

            return {
                ...state,
                loading: true
            };
        case FETCH_COMPACTING_REPORTS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingReportData: updatePayload
            };
        // case FETCH_COMPACTING_REPORTS_DATA_SUCCESS:
        //     return {
        //         ...state,
        //         loading: false,
        //         compactingMasterMainList: updatePayload
        //     };
        case FETCH_COMPACTING_REPORTS_DATA_FAILURE:

            return {
                ...state,
                loading: false
            };
        case SET_SUMMARY_GRID_NAME_COMPACTING_REPORT_DK:
            return {
                ...state,
                renderGridBtn: payload
            };

        case CREATE_USER_FORM_COMPACTING_REPORT:
            return {
                ...state,
                loading: false,
                compactingWiseUserform: {
                    ...state.compactingWiseUserform,
                    [payload.key]: payload.value
                }
            }

        default:
            return state;
    }
};